export const buttonThemeToTailwindClasses = (theme: any) => {
    return ["button", "bg-primary", "text-white", "px-4", "py-2", "rounded"];
};
